import React, { Component } from "react";
import "./style.css";
import Firebase from "../../firebase";

declare const document, gapi: any;

class GoogleSignin extends Component {
    state = {
        fb: Firebase.getInstance(),
    };

    componentDidMount() {
        setTimeout(async () => {
            await gapi.signin2.render("my-signin2", {
                scope: "profile email",
                width: 240,
                height: 50,
                longtitle: true,
                theme: "dark",
                onsuccess: (e: any) => {
                    console.log(e);
                },
                onfailure: (e: any) => {
                    console.log(e);
                },
            });
            var timer = setInterval(() => {
                const clicker = document.getElementsByClassName("abcRioButton abcRioButtonBlue")[0];
                if (clicker) {
                    clicker.onclick = null;
                    clearInterval(timer);
                }
            }, 100);
        }, 100);
    }

    render() {
        return (
            <div>
                <div
                    id="my-signin2"
                    onClick={async (e: any) => {
                        const res = await this.state.fb.googleSignin();
                        console.log(res);
                        if (res.message) return;
                        const userData = await this.state.fb.readData("users/public/$uid");
                        if (!userData) {
                            const user = await this.state.fb.getUser();
                            await this.state.fb.setUserData(user.displayName);
                        }
                    }}
                />
            </div>
        );
    }
}
export default GoogleSignin;
